import type { EnquiryRecord, EnquiryStatus } from '../types'

export const enquiryStatuses: EnquiryStatus[] = ['open', 'replied', 'closed']

export const enquiryStatusLabels: Record<EnquiryStatus, string> = {
  open: 'Open',
  replied: 'Replied',
  closed: 'Closed',
}

export const enquiryEntries: EnquiryRecord[] = [
  {
    id: 'enq-1',
    customer: { name: 'John Smith', email: 'john@email.com', phone: '+43 662 123456' },
    subject: 'Private Tour: Sound of Music & Hallstatt',
    message:
      '=== PRIVATE TOUR ENQUIRY ===\nTour: Sound of Music & Hallstatt Tour\nPickup Location: Salzburg Old Town Hotel\nDeparture: 2026-10-10 at 09:00\nTravelers: 4 Adults, 2 Children (Total: 6)\nEstimated Price: €620\nSelected Vehicle: Mercedes Benz V-Class\n\n=== CUSTOMER INFORMATION ===\nName: John Smith\nEmail: john@email.com\nPhone: +43 662 123456\nSpecial Notes: We would love photo stops at Mirabell and Wolfgangsee.',
    tour_title: 'Sound of Music & Hallstatt Tour',
    pickup_location: 'Salzburg Old Town Hotel',
    departure_date: '2026-10-10',
    departure_time: '09:00',
    adults: 4,
    children: 2,
    estimated_price: 620,
    vehicle: 'Mercedes Benz V-Class',
    notes: 'We would love photo stops at Mirabell and Wolfgangsee.',
    status: 'open',
    submittedAt: '2026-08-03T11:20:00',
  },
  {
    id: 'enq-2',
    customer: { name: 'Anna Keller', email: 'anna.keller@email.com', phone: '+43 664 5544332' },
    subject: 'Private Tour: Eagle\'s Nest & Berchtesgaden',
    message:
      '=== PRIVATE TOUR ENQUIRY ===\nTour: Eagle\'s Nest & Berchtesgaden Alpine Tour\nPickup Location: Salzburg Train Station\nDeparture: 2026-10-14 at 09:30\nTravelers: 3 Adults, 0 Children (Total: 3)\nEstimated Price: €480\nSelected Vehicle: Mercedes Benz V-Class\n\n=== CUSTOMER INFORMATION ===\nName: Anna Keller\nEmail: anna.keller@email.com\nPhone: +43 664 5544332\nSpecial Notes: English speaking driver requested.',
    tour_title: 'Eagle\'s Nest & Berchtesgaden Alpine Tour',
    pickup_location: 'Salzburg Train Station',
    departure_date: '2026-10-14',
    departure_time: '09:30',
    adults: 3,
    children: 0,
    estimated_price: 480,
    vehicle: 'Mercedes Benz V-Class',
    notes: 'English speaking driver requested.',
    status: 'replied',
    submittedAt: '2026-07-28T16:05:00',
  },
  {
    id: 'enq-3',
    customer: { name: 'Marco Rossi', email: 'marco.rossi@email.com', phone: '+39 02 1234567' },
    subject: 'Private Tour: Austrian Lakes & Mountains',
    message:
      '=== PRIVATE TOUR ENQUIRY ===\nTour: Austrian Lakes & Mountains Panorama\nPickup Location: Hotel Sacher, Salzburg\nDeparture: 2026-09-18 at 08:30\nTravelers: 2 Adults, 2 Children (Total: 4)\nEstimated Price: €540\nSelected Vehicle: Mercedes Benz V-Class\n\n=== CUSTOMER INFORMATION ===\nName: Marco Rossi\nEmail: marco.rossi@email.com\nPhone: +39 02 1234567\nSpecial Notes: Need booster seat for child.',
    tour_title: 'Austrian Lakes & Mountains Panorama',
    pickup_location: 'Hotel Sacher, Salzburg',
    departure_date: '2026-09-18',
    departure_time: '08:30',
    adults: 2,
    children: 2,
    estimated_price: 540,
    vehicle: 'Mercedes Benz V-Class',
    notes: 'Need booster seat for child.',
    status: 'closed',
    submittedAt: '2026-06-22T09:40:00',
  },
]
